/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type shifts_UpdateTemplateRequest = {
    /**
     * Optional break end time in HH:MM 24-hour format (e.g., "13:00"). Local to the organization's timezone.
     */
    break_end?: string;
    /**
     * Break duration in minutes (subtracted from gross hours to calculate net hours)
     */
    break_minutes?: number;
    /**
     * Optional break start time in HH:MM 24-hour format (e.g., "12:00"). Local to the organization's timezone.
     */
    break_start?: string;
    /**
     * Optional color for calendar display (hex format)
     */
    color?: string;
    /**
     * Timestamp of when the template was last updated, used for optimistic locking (RFC3339 format)
     */
    current_updated_at: string;
    /**
     * End time in HH:MM 24-hour format (e.g., "16:00"). Local to the organization's timezone.
     */
    end_time: string;
    /**
     * Name of the template
     */
    name: string;
    /**
     * Type of shift: REGULAR (standard work), OVERTIME (extra hours), ON_CALL (availability)
     */
    shift_type: shifts_UpdateTemplateRequest.shift_type;
    /**
     * Start time in HH:MM 24-hour format (e.g., "08:00"). Local to the organization's timezone.
     */
    start_time: string;
};
export namespace shifts_UpdateTemplateRequest {
    /**
     * Type of shift: REGULAR (standard work), OVERTIME (extra hours), ON_CALL (availability)
     */
    export enum shift_type {
        REGULAR = 'REGULAR',
        OVERTIME = 'OVERTIME',
        ON_CALL = 'ON_CALL',
    }
}

